import { format } from "date-fns";
import { Domains } from "@/core/types/types";
import { timeFormats } from "@/core/data";
import getTopLevelDomain from "./getTopLevelDomain";

const getFormattedTime = (dateIso: string): string => {
  const domain: Domains = getTopLevelDomain() as Domains;
  const timeFormat: string = timeFormats[domain];
  return format(new Date(dateIso), timeFormat);
};

export default getFormattedTime;
